import React from 'react';

function SummaryCards({ initialInvestment, totalWeeks, requiredReturn, targetNetValue, startDate, endDate }) {
  // Calculate duration in years and weeks
  const durationWeeks = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24 * 7));
  const durationYears = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24 * 365.25) * 10) / 10;

  return (
    <div className="summary-cards">
      <div className="card">
        <h3>Initial Investment</h3>
        <div className="value">
          ${initialInvestment.toLocaleString()}
        </div>
      </div>
      <div className="card">
        <h3>Target Net Value</h3>
        <div className="value">
          ${targetNetValue?.toLocaleString() || '2,000,000'}+
        </div>
      </div>
      <div className="card">
        <h3>Investment Period</h3>
        <div className="value">
          {durationYears} years
        </div>
        <div className="sub-value">
          {durationWeeks} weeks
        </div>
      </div>
      <div className="card">
        <h3>Required Annual Return</h3>
        <div className="value">
          {requiredReturn?.toFixed(1) || '15.2'}%
        </div>
      </div>
    </div>
  );
}

export default SummaryCards;
